import LoggingIcon from '@mui/icons-material/EmojiPeopleTwoTone';
import ApartmentsList from './ApartmentsList';

export default {
    list: ApartmentsList,
    icon: LoggingIcon
}